import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CompareProvider } from "./context/CompareContext";
import CompareBar from "./components/feature/CompareBar";
import TopBanner from "./components/feature/TopBanner";
import CookieConsent from "./components/feature/CookieConsent";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <CompareProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <TopBanner />
          <AppRoutes />
          <CompareBar />
          <CookieConsent />
        </BrowserRouter>
      </CompareProvider>
    </I18nextProvider>
  );
}

export default App;
